<template>
  <div v-loading="pageLoading">
    <div>
      <el-form :inline="true"
               :model="greenForm"
               label-width="72px"
               class="demo-form-inline">
        <el-form-item label="職員編號">
          <el-input v-model="greenForm.workNo"
                    clearable
                    placeholder="請輸入職員編號"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="greenForm.name"
                    clearable
                    placeholder="請輸入姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn"
                     type="primary"
                     @click="onSearch">搜尋</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <template>
        <el-table ref="singleTable"
                  :data="tableData"
                  empty-text="暫無記錄"
                  style="width: 100%"
                  height="500"
                  border>
          <el-table-column label="员工编号"
                           property="workNo"></el-table-column>
          <el-table-column label="姓名"
                           property="name"></el-table-column>
          <el-table-column label="操作"
                           fixed="right">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="primary"
                         @click="view(scope.row)">查看詳情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-pagination :hide-on-single-page="true"
                     :total="total"
                     :page-sizes="[20, 50, 100]"
                     :page-size="50"
                     style="margin-top: 10px"
                     layout="prev, pager, next,total"
                     @current-change="pageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageLoading: false,
      uploadLoading: false,
      searchLoading: false,
      tableData: [],
      total: 0,
      greenForm: {
        workNo: "",
        name: "",
        pageNum: 1,
        pageSize: 50
      }
    };
  },
  computed: {

  },
  mounted() {
    $("#pageHead").text("綠綠賞積分");
    this.greenIntegralList()
  },
  methods: {
    view(row) {
      sessionStorage.greenIntegralParams = JSON.stringify(row);
      this.$router.push("/esg/greenIntegralDetail");
    },
    onSearch() {
      this.greenForm.pageNum = 1;
      this.greenIntegralList()
    },
    greenIntegralList() {
      var msg = this.utils.filtration(this.greenForm);
      this.pageLoading = true
      this
        .axios({
          url: "/manage/getExternalEcycleTerUserList",
          params: msg,
          paramsSerializer: (params) => {
            return this.qs.stringify(params, {
              arrayFormat: "indices",
            });
          },
        })
        .then((res) => {
          console.log("res", res)
          this.total = res.total;
          this.tableData = res.result;
          this.pageLoading = false
        });
    },
    pageChange(val) {
      this.greenForm.pageNum = val;
      this.greenIntegralList();
    },
  },
  created() {

  },
};
</script>

<style lang="scss" scoped>
.float {
  position: absolute;
  top: 90px;
  right: 45px;
  display: flex;
}
.btn {
  margin-left: 20px;
}
.demo-form-inline >>> .el-form-item__label {
  width: auto;
}
</style>
